import { ComponentConfig } from '@measured/puck';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import { MarginProps, marginFields } from '../../puck/reusable-props/margin';
import CustomTooltip from '../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../services/constants';
import './../text-editor/style.scss';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import {
  paddingFields,
  paddingProps,
  PaddingProps,
} from '../../puck/reusable-props/padding';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import Marquee from './marquee';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';

export type TextBannerProps = {
  content: string;
  speed: number;
  border: IBorderValueProps;
  flowDirection: 'left' | 'right';
  background: {
    color: string;
    isInherit: boolean;
  };
  removeGap: boolean;
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const TextBanner = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<TextBannerProps> => {
  return {
    label: (
      <CustomTooltip title="TextBanner">
        <span>Text Banner</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      content: {
        ...QuillTextEditor('Content').content,
      },
      flowDirection: {
        type: 'select',
        label: 'Flow Direction',
        options: [
          { label: 'Left to Right', value: 'left' },
          { label: 'Right to Left', value: 'right' },
        ],
      },
      speed: {
        type: 'number',
        label: 'Speed (in sec)',
        min: 1,
        max: 100,
      },
      removeGap: {
        type: 'radio',
        label: 'Remove Gap',
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ],
      },
      ...backgroungFields,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        label: 'Border',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={value => onChange({ ...value })}
            title="Border"
          />
        ),
      },
    },
    defaultProps: {
      removeGap: false,
      speed: 25,
      showComponent: ['desktop', 'tablet', 'mobile'],
      flowDirection: 'left',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      content:
        '<p style="line-height:1.5;"><span style="font-size: 14px;">🚨 ONCE YOU LEAVE, THIS DEAL IS GONE!</span></p>',
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },

      ...paddingProps,
      ...borderProps,
    },
    render: ({
      content,
      margin,
      editMode,
      padding,
      border,
      showComponent,
      background,
      flowDirection,
      speed,
      removeGap,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              className={`${border?.borderStyle?.[currentDeviceType]} w-full`}
              style={{
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
                ...marginStyles,
                ...getBorderProps(border, currentDeviceType),
                ...getPaddingStyles(padding, currentDeviceType),
              }}>
              <Marquee
                text={content}
                direction={flowDirection}
                speed={speed}
                isLegacyMode={!removeGap}
              />
            </div>
          )}
        </>
      );
    },
  };
};
